import { Heading, VStack } from '@rtkwlf/fenrir-react';
import type { Attachment } from '@rtkwlf/track-public';

import { Markdown } from 'ae-components/markdown/Markdown';

import { useSecurityJourneyTranslations } from '../locales/use-security-journey-translations';

import { AttachmentsList } from './attachments-list';
import styles from './spidr-details.module.css';

/* -------------------------------------------------------------------------------------------------
 * SpidrMarkdown
 * -----------------------------------------------------------------------------------------------*/
type SpidrMarkdownProps = {
  title: string;
  value: string[];
};

const SpidrMarkdown: React.FC<SpidrMarkdownProps> = ({ title, value }) => {
  return (
    <VStack width="full">
      <Heading level="5">{title}</Heading>
      <VStack width="full" className={styles['markdown-background']}>
        <Markdown textColor="secondary" value={value.join('\n')} />
      </VStack>
    </VStack>
  );
};

/* -------------------------------------------------------------------------------------------------
 * SpidrDetails
 * -----------------------------------------------------------------------------------------------*/
type SpidrDetailsProps = {
  customerActionItems: string[];
  customerRecommendations: string[];
  cstActionItems: string[];
  attachments: Attachment[];
  noCstActionItems: boolean;
  noCustomerActionItems: boolean;
};

export const SpidrDetails: React.FC<SpidrDetailsProps> = ({
  customerActionItems,
  customerRecommendations,
  cstActionItems,
  attachments,
  noCustomerActionItems,
  noCstActionItems,
}) => {
  const { t } = useSecurityJourneyTranslations();

  return (
    <VStack gap="large" className={styles['spidr-details']}>
      <SpidrMarkdown
        title={t('spidrID.myActionItems')}
        value={
          noCustomerActionItems
            ? [t('spidrID.noCustomerActionItems')]
            : customerActionItems
        }
      />
      <SpidrMarkdown
        title={t('spidrID.myRecommendations')}
        value={customerRecommendations}
      />
      <SpidrMarkdown
        title={t('spidrID.cstActionItems')}
        value={
          noCstActionItems ? [t('spidrID.noCstActionItems')] : cstActionItems
        }
      />
      <Heading level="5" marginTop="medium">
        {t('spidrID.attachments.header')}
      </Heading>
      <AttachmentsList attachments={attachments} />
    </VStack>
  );
};
